import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Table from '@deprecated-ui/common/Table';
import Input from '@deprecated-ui/common/Input';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';

export const HeaderBox = styled(Flex).attrs({ direction: 'column' })`
  padding: 12px 20px;

  :last-child {
    border: unset;
  }
`;

export const HeaderContainer = styled.div`
  border: 1px solid ${color.gainsboro};
  grid-template-columns: repeat(2, 2fr);
  grid-template-rows: 2fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  background: white;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 4px;

  ${HeaderBox} {
    display: inline-block;
    width: calc(100% / 3);
    border-right: 1px solid ${color.gainsboro};
    border-bottom: 1px solid ${color.gainsboro};

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    :nth-child(3),
    :nth-child(5) {
      border-right: unset;
    }
    :nth-child(4),
    :nth-child(5) {
      border-bottom: unset;
      width: 50%;
    }
  }

  @media ${device.tablet} {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr;
    ${HeaderBox} {
      display: block;
      width: 100% !important;
      border-right: 1px solid ${color.gainsboro}!important;
      border-bottom: none;

      :last-child {
        border-right: unset !important;
      }
    }
  }
`;

export const CellLabel = styled(Text).attrs({
  color: color.midgray,
  size: '12px',
  align: 'inherit',
})``;

export const PortfolioTable = styled(Table)`
  width: 100%;
  max-width: 1250px;
  cursor: pointer;
  .ant-table-thead > tr > th {
    height: 17px;
    font-size: 14px;
    border-top: 1px solid ${color.gainsboro};
    border-bottom: 1px solid ${color.gainsboro};
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: 1px solid ${color.gainsboro};
  }

  .ant-pagination {
    display: none;
  }

  .ant-table-thead > tr > th {
    font-size: 14px;
    border-top: 1px solid ${color.gainsboro};
    border-bottom: 1px solid ${color.gainsboro};

    &:nth-child(1) {
      border-left: 1px solid ${color.gainsboro};
    }

    &:nth-child(10) {
      border-right: 1px solid ${color.gainsboro};
    }
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td:not(.td-mobile) {
    display: none;
  }

  .ant-table-content {
    overflow-x: unset;
  }

  .ant-table-tbody > tr > td {
    &:nth-child(1) {
      border-left: 1px solid ${color.gainsboro};
      font-family: var(--font-bold);
    }

    &:nth-child(10) {
      border-right: 1px solid ${color.gainsboro};
    }
  }

  .ant-table-tbody > tr > .td-mobile:first-child {
    display: block;
    width: 100vw;
    border-width: 0;
    height: 25px;
  }

  /* Invested column */
  .ant-table-tbody > tr > td:nth-child(6) {
    text-align: left !important;
  }
  /* Action column */
  .ant-table-tbody > tr > td:last-child > div {
    height: 37px;
  }

  .ant-table-tbody > tr > .td-mobile {
    display: inline-block;
    width: calc(100vw / 4);
  }

  ${CellLabel} {
    display: block;
  }

  .ant-table-empty .ant-table-tbody > tr > td {
    border-right: 1px solid ${color.gainsboro};
  }

  .ant-table-row.empty-row {
    cursor: default;
    background-color: #f7f7f7;

    > .ant-table-cell {
      background-color: #f7f7f7;
      border-right: none;
      &:nth-child(1) {
        border-left: 1px solid ${color.gainsboro};
        font-family: var(--font-bold);
      }

      &:nth-child(10) {
        border-right: 1px solid ${color.gainsboro};
      }
    }
  }

  @media ${device.mobileL} {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td:not(.td-mobile) {
      display: table-cell;
    }

    .ant-table-content {
      overflow-x: auto;
    }

    .ant-table-tbody > tr > .td-mobile:first-child,
    .ant-table-tbody > tr > .td-mobile {
      display: table-cell;
      width: inherit;
      border-width: 1px;
    }

    /* Invested column */
    .ant-table-tbody > tr > td:nth-child(6) {
      text-align: right !important;
    }
    /* Action column */
    .ant-table-tbody > tr > td:last-child > div {
      height: unset;
    }

    ${CellLabel} {
      display: none;
    }
  }
`;

export const SpinnerBox = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  position: relative;
  background: ${color.light};
  height: 200px;
  width: 100%;
  border: 1px solid ${color.gainsboro};
`;

export const CancelButton = styled(Button).attrs({ ml: '10px' })`
  height: 20px;
  width: 20px;
  padding: unset;

  &[disabled] {
    background: #dadada;
    border: 1px solid #dadada;
    color: #ffffff;

    &:hover {
      background: #dadada;
      border: 1px solid #dadada;
      color: #ffffff;
    }
  }
`;

export const AlertCancelButton = styled(Button)`
  background: #f7f7f7;
  height: 35px;
  width: 75px;
`;

export const DescInput = styled(Input.TextArea)`
  ::placeholder {
    color: ${color.gainsboro};
    font-family: var(--font-bold);
  }
`;

export const Filter = styled(Flex)`
  padding: 8px 14px;
  flex-direction: column;

  > div:first-child {
    margin-bottom: 10px;
  }

  @media ${device.mobileL} {
    flex-direction: row;

    > div {
      margin-bottom: 0 !important;
    }
  }
`;

export const FilterButton = styled.button`
  padding: 8px 16px;
  background: none;
  border: none;
  color: ${color.midgray};
  border: 1px solid transparent;

  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  cursor: pointer;

  &.active {
    border: 1px solid ${color.gainsboro};
    border-radius: 2px;
    color: ${color.primary};
  }
`;

export const TradingContainer = styled.div`
  width: 100%;
  border: 1px solid ${color.gainsboro};
  max-width: 1250px;
  background: ${color.light};
`;

export const ModalButtonContainer = styled(Flex)`
  position: absolute;
  bottom: -60px;
  left: 0px;
  width: 100%;
  gap: 12px;
`;

export const ModalTradingButton = styled(Button)`
  width: 100%;
  height: 44px;
  font-size: 16px;
  color: ${color.light} !important;
  font-family: var(--font-bold);
  background: ${color.dimGray};
  border-color: ${color.dimGray};

  &.sell {
    background: ${color.sunsetOrange};
    border-color: ${color.sunsetOrange};
  }

  &.exercise {
    background: ${color.primary};
    border-color: ${color.primary};
  }

  &.support {
    background: ${color.primary};
    border-color: ${color.primary};
    font-size: 14px;
  }

  .icon-widget_support {
    color: ${color.light};
    margin-right: 5px;
    font-size: 16px;
    font-weight: bold;
  }

  &:disabled,
  &:hover:disabled {
    background: #616161;
    border-color: #616161;
    color: #cbcbcb;
    cursor: not-allowed;
  }
`;

export const DiscoverButton = styled(Button)`
  text-decoration: none;
  padding: 6px 20px;
  border-radius: 4px;
  border: 1px solid ${color.primary};

  &:hover {
    border: 1px solid ${color.primary};
  }
`;
